import { render } from "./PageHeaderWithMenu.vue?vue&type=template&id=5787b545&scoped=true&ts=true"
import script from "./PageHeaderWithMenu.vue?vue&type=script&lang=ts"
export * from "./PageHeaderWithMenu.vue?vue&type=script&lang=ts"

import "./PageHeaderWithMenu.vue?vue&type=style&index=0&id=5787b545&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5787b545"]])

export default __exports__